import useAwards from "@/hooks/useAwards";
import cn from "classnames";
import { Col, Container, Row } from "react-bootstrap";

import classes from "./styles.module.scss";

export default function ({ className }) {
  const awards = useAwards();

  const years = awards.reduce(
    (acc, current) => ({ ...acc, [current.year]: [...(acc[current.year] ?? []), current] }),
    {},
  );

  return (
    <div className={cn(className, classes.AwardsFeed)}>
      <Container>
        {Object.keys(years)
          .sort((a, b) => b - a)
          .map((year) => (
          <div key={year} className="year mb-4">
            <h3>Awards in {year}</h3>
            <Row>
              {years[year].map((item) => (
                <Col xs={12} md={6} lg={4} xl={3} key={item.id}>
                  <div className="award">
                    <div>
                      <img src={item.image} alt="" />
                    </div>
                    <div className="py-4">
                      <h6 className="mb-2">{item.name}</h6>
                      <p>{item.title}</p>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        ))}
      </Container>
    </div>
  );
}
